export default "__VITE_ASSET__77731f90__"